import Card from './Card.vue';
import { NAME } from './constants';
import { router } from './router';

export const Zapujcky = {
	name: NAME,
	router,
	components: {
		Card,
	},
};
